import { writable } from "svelte/store"

/**
 * @type {BulkUploadFlow}
 */
let releaseData = localStorage.getItem("P2BReleaseDoc")

if (typeof releaseData != "Object") {
  try {
    releaseData = JSON.parse(releaseData)
    if (!releaseData) {
      throw new Error("P2BReleaseDoc value is null")
    }
  } catch (error) {
    releaseData = {
      selected: [],
      notSelected: [],
      previouslySelected: [],
      selectChecked: false,
    }
  }
}

/**
 * @typedef {Object} ReleaseObj - represents the object containing selected entries to be released and not selected
 * @type {Object}
 * represents the object containing selected entries to be released and not selected
 *
 * @property {Array<String>} selected - selected entries (document id) to be released
 * @property {Array<String>} notSelected - other than selected entries (document id)
 * @property {Array<String>} previouslySelected - previously selected entries (document id)
 */

/**
 * @type {import("svelte/store").Writable<ReleaseObj>}
 */
const ReleaseData = writable(releaseData)

/**
 * updating the bulk upload publishing process variables to the local Storage
 * @param {ReleaseObj} releaseData
 */
ReleaseData.subscribe((releaseData) => {
  localStorage.setItem("P2BReleaseDoc", JSON.stringify(releaseData))
})

export default ReleaseData
